module.exports = __webpack_public_path__ + "img/KurdoShaban-PrBaPest.fe026c64.jpg";